import { IMAGES_BASE_URL } from '../../../config/constants';
import './Rotating.scss';

const Rotating = ({ frontImage, backImage }) => {

    const getFullUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http')) return path;
        return `${IMAGES_BASE_URL}${path}`;
    };

    return (
        <div className='logo__container'>
            <div className='logo'>
                <div className='logo__inner'>
                    <div className='logo__front'>
                        <img src={getFullUrl(frontImage)} alt='front-logo' loading="lazy"/>
                    </div>
                    <div className='logo__back'>
                        <img src={getFullUrl(backImage)} alt='back-logo' loading="lazy"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rotating;